import axios from 'axios';
import logoutCleanup from './logout-cleanup';

export const API_URL = import.meta.env.VITE_APP_API_URL;
export const API_ADDRESS_URL = import.meta.env.VITE_APP_API_ADDRESS_URL;

export const setCookie = function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/;`;
};

export const getCookie = function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const HTTP = axios.create({
  baseURL: API_URL,
});
HTTP.defaults.withCredentials = true;

export const HTTP_ADDRESS = axios.create({
  baseURL: API_ADDRESS_URL,
});
HTTP_ADDRESS.defaults.withCredentials = true;

export const setAuthLocalStorage = function setAuthLocalStorage(response) {
  if (response.data.model.accessToken) {
    localStorage.setItem('account', JSON.stringify(response.data.model));
  }
};

export const getAccountFromLocalStorage = function getAccountFromLocalStorage() {
  return JSON.parse(localStorage.getItem('account'));
};

export const authHeader = function authHeader() {
  const account = getAccountFromLocalStorage();
  if (account) {
    return { Authorization: `Bearer ${account.accessToken}` };
  }
  return {};
};

function onError(error) {
  const originalRequest = error.config;
  if (error.response.status === 401 && !originalRequest.retry) {
    originalRequest.retry = true;

    if (!getAccountFromLocalStorage()) {
      logoutCleanup();
      return Promise.reject(new Error('Session has expired - login is required'));
    }

    const refreshRequest = {
      refreshToken: getAccountFromLocalStorage().refreshToken,
      username: getAccountFromLocalStorage().accountName,
    };

    return axios
      .post(`${API_URL}auth/refresh`, refreshRequest, {
        withCredentials: true,
        headers: authHeader(),
      })
      .then((resp) => {
        if (resp.status === 200) {
          setAuthLocalStorage(resp);

          try {
            const storageToken = getAccountFromLocalStorage().accessToken;
            const newToken = resp.data.model.accessToken;
            originalRequest.headers.Authorization = `Bearer ${
              storageToken ?? newToken
            }`;
            return axios(originalRequest);
          } catch (error) {

          }
        } else {
          logoutCleanup();
          return Promise.reject(new Error('Refresh was not successful - login is required'));
        }
      })
      .catch((err) => {
        console.log(err);
        logoutCleanup();
        return Promise.reject(new Error('Failed to refresh - login is required'));
      });
  }
  if (error.response.status === 422) {
    if (error.response.data.reasons) {
      const reasons = error.response.data.reasons.map((x) => `${x.field} ${x.reason}`).join(', ');
      return Promise.reject(reasons);
    }
    if (error.response.data.message) {
      return Promise.reject(error.response.data.message);
    }
  }
  return Promise.reject(error);
}

HTTP.interceptors.response.use((response) => {
  return response;
}, onError);

HTTP_ADDRESS.interceptors.response.use((response) => {
  return response;
}, onError);
